import { CircularProgress } from '@mui/material';
import React from 'react';
import { AccessControlledComponents } from '~/constants';
import useAppContext from '~/hooks/useAppContext';

interface AccessControlComponentProps {
	componentName: AccessControlledComponents;
	DefaultComponent?: React.JSX.Element;
	AuthComponent?: React.JSX.Element;
	withLoadingSpinner?: boolean;
	children?: React.JSX.Element;
}

export const AccessControlComponent = ({
	componentName,
	withLoadingSpinner = false,
	AuthComponent,
	DefaultComponent,
	children,
}: AccessControlComponentProps) => {
	const { hasComponentAccess, dashboardAccessConfigLoading } = useAppContext();
	const hasAccess = hasComponentAccess(componentName);

	if (withLoadingSpinner && dashboardAccessConfigLoading) {
		return <CircularProgress size={35} data-cy='access-control-loading-indicator' />;
	}

	if (hasAccess) {
		return AuthComponent ?? children;
	}

	if (DefaultComponent) {
		return DefaultComponent;
	}

	return null;
};
